import { makeStyles } from "@material-ui/core/styles";

export const useFlyerHeaderViewStyles = makeStyles(() => ({
  addButton: {
    color: "#000",
    "&:not(.Mui-disabled)": {
      borderColor: "#000 !important",
    },
  },
}));
